import { Box, IconButton, Image, Theme, Typography } from "@outschool/backpack";
import { faArrowRight } from "@outschool/icons";
import { TESTIMONIALS } from "@outschool/ui-components-website";
import React from "react";

import TestimonialBottomDoodle from "../../../images/homepage/home_hero/testimonial-bottom-doodle.webp";
import TestimonialTopDoodle from "../../../images/homepage/home_hero/testimonial-top-doodle.webp";
import TestimonialAmy from "../../../images/homepage/home_hero/testimonials/Testimonial_Amy.webp";
import TestimonialAudra from "../../../images/homepage/home_hero/testimonials/Testimonial_Audra.webp";
import TestimonialShauna from "../../../images/homepage/home_hero/testimonials/Testimonial_Shauna.webp";
import TestimonialSilas from "../../../images/homepage/home_hero/testimonials/Testimonial_Silas.webp";
import TestimonialXaviera from "../../../images/homepage/home_hero/testimonials/Testimonial_Xaviera.webp";

export const Testimonials = React.forwardRef(
  (props: {}, ref: React.Ref<any>) => {
    const [currentIndex, setCurrentIndex] = React.useState(0);
    const startXRef = React.useRef<number | null>(null);

    const goToSlide = (index: number) => {
      setCurrentIndex(index);
    };

    const goToNext = () => {
      setCurrentIndex(prev => (prev + 1) % TESTIMONIALS.length);
    };

    const goToPrevious = () => {
      setCurrentIndex(prevIndex =>
        prevIndex === 0 ? TESTIMONIALS.length - 1 : prevIndex - 1
      );
    };

    const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
      startXRef.current = e.touches[0].clientX;
    };

    const handleTouchEnd = (e: React.TouchEvent<HTMLDivElement>) => {
      const endX = e.changedTouches[0].clientX;
      const diffX = startXRef.current ?? 0 - endX;

      if (diffX > 50) {
        goToNext(); // swipe left
      } else if (diffX < -50) {
        goToPrevious(); // swipe right
      }
    };

    const avatars = [
      TestimonialXaviera,
      TestimonialAmy,
      TestimonialAudra,
      TestimonialShauna,
      TestimonialSilas
    ];

    return (
      <Box
        sx={{
          position: "relative"
        }}
      >
        <Box
          sx={(theme: Theme) => ({
            position: "absolute",
            top: "-43px",
            left: "0",
            zIndex: 1,
            [theme.breakpoints.down("md")]: { display: "none" }
          })}
        >
          <Image
            src={TestimonialTopDoodle}
            alt={`doodle`}
            width={88}
            height={206}
          />
        </Box>
        <Box
          sx={(theme: Theme) => ({
            position: "absolute",
            bottom: "-130px",
            right: "0",
            zIndex: 1,
            [theme.breakpoints.down("md")]: { display: "none" }
          })}
        >
          <Image
            src={TestimonialBottomDoodle}
            alt={`doodle`}
            width={109}
            height={251}
          />
        </Box>
        <Box
          ref={ref}
          sx={(theme: Theme) => ({
            backgroundColor: "warning.400",
            position: "relative",
            paddingTop: "7em",
            paddingBottom: "4em",
            marginBottom: "12rem",
            overflow: "hidden",
            [theme.breakpoints.down("md")]: {
              paddingY: "4em",
              marginBottom: "4em"
            }
          })}
        >
          <Box
            sx={(theme: Theme) => ({
              display: "flex",
              marginX: "auto",
              maxWidth: "1120px",
              gap: "2em",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              height: "400px",
              [theme.breakpoints.down("md")]: {
                alignItems: "center"
              },
              [theme.breakpoints.down("sm")]: {
                height: "700px"
              }
            })}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            {TESTIMONIALS.map((testimonial, index) => (
              <Box
                key={index}
                sx={(theme: Theme) => ({
                  display: "flex",
                  flexDirection: "row",
                  gap: "2em",
                  position: "absolute",
                  transition:
                    "opacity 0.5s ease-in-out, transform 0.5s ease-in-out",
                  opacity: index === currentIndex ? 1 : 0,
                  transform:
                    index === currentIndex
                      ? "translateX(0)"
                      : index === currentIndex - 1
                      ? "translateX(-100%)"
                      : "translateX(100%)",
                  [theme.breakpoints.down("md")]: {
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center"
                  }
                })}
              >
                <Box sx={{ width: "200px" }}>
                  <Image
                    src={avatars[index]}
                    alt={testimonial.authorName}
                    width={200}
                    height={200}
                  />
                </Box>
                <Box
                  sx={(theme: Theme) => ({
                    maxWidth: "780px",
                    height: "425px",
                    [theme.breakpoints.down("md")]: {
                      paddingX: "1em",
                      height: "auto"
                    }
                  })}
                >
                  <Typography
                    variant="display2"
                    sx={{ color: "primary.700", marginBottom: "0.5em" }}
                  >
                    &quot;
                    <br />
                    {testimonial.testimonialText}&quot;
                  </Typography>
                  <Typography variant="h5" sx={{ color: "primary.700" }}>
                    - {testimonial.authorName}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            {TESTIMONIALS.map((_, index) => (
              <Box
                as="span"
                sx={(theme: Theme) => ({
                  width: 8,
                  height: 8,
                  backgroundColor:
                    index === currentIndex ? "primary.700" : "warning.400",
                  borderRadius: "50%",
                  display: "inline-block",
                  cursor: "pointer",
                  marginX: "0.1em",
                  border: `1px solid ${theme.palette.primary[700]}`,
                  transition: "background-color 0.3s ease"
                })}
                key={index}
                onClick={() => goToSlide(index)}
              ></Box>
            ))}
            <IconButton
              variant="ghost"
              icon={faArrowRight}
              onClick={goToNext}
            />
          </Box>
        </Box>
      </Box>
    );
  }
);
